module.exports = __webpack_public_path__ + "static/media/phase one - 300px.1c57a890.png";